module.exports = __webpack_public_path__ + "static/media/5loyalty_logo.994ee3c0.svg";